
/** Data Layer helper for consistent event pushes */
export const dlPush = (event, params = {}) => {
  if (!window.dataLayer) window.dataLayer = [];
  const payload = { event, ...params, event_time: new Date().toISOString() };
  window.dataLayer.push(payload);
  // Helpful for debugging while you learn
  // eslint-disable-next-line no-console
  console.log('dataLayer.push ->', payload);
};
